import FormattedMessage from 'I18n/components/FormattedMessage';
import { getDisplayParamsHideMarkers } from 'reporting-data/report/configReportGetters';
import { setDisplayParamsHideMarkers } from 'reporting-data/report/configReportSetters';
import BaseCheckboxComponent from '../shared-components/BaseCheckboxComponent';
import { getIsReportValidForHideMarkersCheckbox } from './utils';
import { jsx as _jsx } from "react/jsx-runtime";
const ConfigReportHideMarkersCheckbox = BaseCheckboxComponent({
  reportGetter: getDisplayParamsHideMarkers,
  reportSetter: setDisplayParamsHideMarkers,
  getIsReportValidForCheckbox: getIsReportValidForHideMarkersCheckbox,
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "report-customization-components.customization-components.hide-markers-checkbox.config.label"
  })
});
export default ConfigReportHideMarkersCheckbox;